// extracted by mini-css-extract-plugin
export default {"container":"Countdown_container__k9BlF","clock":"Countdown_clock__7kUY+","rotateClockwise":"Countdown_rotateClockwise__2tlEV"};